import "./insGainLossIndicator.scss";
import React from "react";
import { InsEsgVariationIndicator, InsIndicatorTooltip, InsPercentageOfChangeIndicator, InsSimpleChangeIndicator, InsSimplePercentageIndicator } from "./indicators";
import { areFiniteNumbers } from "common/number-helper";
import { VariationFormat } from "store/current-dashboard/types";
export const InsGainLossIndicator = (props) => {
    if (!areFiniteNumbers(props.oldValue, props.newValue)) {
        return React.createElement(React.Fragment, null);
    }
    const signDisplay = props.variationSettings.showPrefix ? "exceptZero" : "auto";
    const indicatorProps = { ...props, signDisplay };
    const getChangeTooltipContent = () => {
        switch (props.variationSettings.format) {
            case VariationFormat.percentageOfChange:
                return React.createElement(InsPercentageOfChangeIndicator, { ...indicatorProps });
            case VariationFormat.simpleChange:
                return React.createElement(InsSimpleChangeIndicator, { ...indicatorProps });
            case VariationFormat.simplePercentage:
                return React.createElement(InsSimplePercentageIndicator, { ...indicatorProps });
            default:
                return React.createElement(React.Fragment, null);
        }
    };
    if (props.variationSettings.format === VariationFormat.esgVariation) {
        return React.createElement(InsEsgVariationIndicator, { ...indicatorProps });
    }
    return React.createElement(InsIndicatorTooltip, { ...indicatorProps }, getChangeTooltipContent());
};
